function openSubmenu(el, blockID) {
  const subMenu = document.querySelector(("#drawer_submenu--" + blockID))
  subMenu.classList.add('open')
} 
function closeSubmenu(el, blockID) {
  const subMenu = document.querySelector(("#drawer_submenu--" + blockID))
  subMenu.classList.remove('open')
} 
function openQuestion(el) {
  if(el.parentElement.classList.contains('active'))
    el.parentElement.classList.remove('active')
  else
    el.parentElement.classList.add('active')
}
function checkTerms(event, form) {
  event.preventDefault()
  
  const checkbox = form.querySelector('#agree-terms')
  const button = form.querySelector("button[name='checkout']")
  
  if (checkbox.checked) {
    window.location.href ='/checkout'
    return true
  } else {
    alert("חובה לאשר את התקנון")
    button.classList.remove('btn--loading')
    button.removeAttribute ('disabled')
    return false
  }
}
function openBlock(block, el) {
  let i;
  const tabs = document.getElementsByClassName("tabs-buttons__button")
  const contents = document.getElementsByClassName("product-tabs__block")
  
  for (i = 0; i < tabs.length; i++) {
    tabs[i].classList.remove('active')
    contents[i].classList.remove('active')
  }

  el.classList.add('active')
  document.getElementById(block).classList.add('active')
}

$('.product-media__wrapper').slick({
  dots: true,
  arrows: false,
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  rtl: true,
  fade: true,
  autoplay: true,
  autoplaySpeed: 1000
});

window.addEventListener("scroll", function() {
  const popup = document.querySelector(".atc-popup__wrapper");
  const header = document.querySelector(".product-single");

  if (header && popup) {
    if (window.scrollY > (header.offsetTop + header.offsetHeight)) {
      popup.classList.add('active')
    } else
      popup.classList.remove('active')
  }
});

function openIngreTab(el) {
  const tabs = document.querySelectorAll('.ingre_tabs .tab__block')
  const blocks = document.querySelectorAll('.product_ingredients_block')
  
  tabs.forEach(tab => {
    tab.classList.remove('is-active')
  })

  el.classList.add('is-active')

  blocks.forEach(block => {
    if (block.getAttribute('data-anchor') == el.getAttribute('data-open'))
      block.classList.add('is-active')
    else
      block.classList.remove('is-active')
  })
}

const elements = document.querySelectorAll('.animate-on-scroll');

// Observer for when the element reaches the center of the screen
const centerObserver = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add('is-active'); // Trigger center animation
    }
  });
}, {
  root: null, // Viewport
  rootMargin: '-10% 0px -50% 0px', // Trigger at center, remove 10% before leaving
  threshold: 0, // Trigger as soon as the offset is met
});

elements.forEach((el) => {
  centerObserver.observe(el); // Observe for center trigger
});

function inView(element, callback, options) {
    const observerOptions = {
        root: null, // You can specify a scrollable element as root, `null` means viewport
        rootMargin: options.margin || '0px', // Margin around the root; similar to CSS for the bounding box
        threshold: 0.1 // Threshold about when to trigger the callback, 0.1 means 10% of the element is in view
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) { // Check if the element is intersecting the viewport based on the set options
                callback();
            }
        });
    }, observerOptions);

    observer.observe(element); // Start observing the specified element
}

var BaseMedia = class extends HTMLElement {
  static get observedAttributes() {
    return ["playing"];
  }
  connectedCallback() {
    this._abortController = new AbortController();
    if (this.hasAttribute("autoplay")) {
      inView(this, this.play.bind(this), { margin: "0px 0px 0px 0px" });
    }
  }
  disconnectedCallback() {
    this._abortController.abort();
  }
  get playing() {
    return this.hasAttribute("playing");
  }
  get player() {
    return this._playerProxy = this._playerProxy || new Proxy(this._playerTarget(), {
      get: (target, prop) => {
        return async () => {
          target = await target;
          this._playerHandler(target, prop);
        };
      }
    });
  }
  play() {
    if (!this.playing) {
      this.player.play();
    }
  }
  pause() {
    if (this.playing) {
      this.player.pause();
    }
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "playing") {
      if (oldValue === null && newValue === "") {
        this.dispatchEvent(new CustomEvent("media:play", { bubbles: true }));
        if (this.hasAttribute("group")) {
          Array.from(document.querySelectorAll(`[group="${this.getAttribute("group")}"]`)).filter((item) => item !== this).forEach((itemToPause) => {
            itemToPause.pause();
          });
        }
      } else if (newValue === null) {
        this.dispatchEvent(new CustomEvent("media:pause", { bubbles: true }));
      }
    }
  }
};
var VideoMedia = class extends BaseMedia {
  #mustRemoveControlsAfterSuspend = false;
  connectedCallback() {
    super.connectedCallback();
    if (!this.hasAttribute("autoplay")) {
      this.addEventListener("click", this.play, { once: true, signal: this._abortController.signal });
    }
    if (this.hasAttribute("show-play-button") && !this.shadowRoot) {
      this.attachShadow({ mode: "open" }).appendChild(document.getElementById("video-media-default-template").content.cloneNode(true));
    }
    if (this.getAttribute("type") === "video") {
      inView(this, () => {
        this.querySelector("video")?.setAttribute("preload", "metadata");
      }, { margin: "800px" });
    }
  }
  _playerTarget() {
    if (this.hasAttribute("host")) {
      this.setAttribute("loaded", "");
      return new Promise(async (resolve) => {
        const templateElement = this.querySelector("template");
        if (templateElement) {
          templateElement.replaceWith(templateElement.content.firstElementChild.cloneNode(true));
        }
        const muteVideo = this.hasAttribute("autoplay") || matchesMediaQuery("md-max");
        const script = document.createElement("script");
        script.type = "text/javascript";
        if (this.getAttribute("host") === "youtube") {
          if (!window.YT || !window.YT.Player) {
            script.src = "https://www.youtube.com/iframe_api";
            document.head.appendChild(script);
            await new Promise((resolve2) => {
              script.onload = resolve2;
            });
          }
          await onYouTubePromise;
          const player = new YT.Player(this.querySelector("iframe"), {
            events: {
              "onReady": () => {
                if (muteVideo) {
                  player.mute();
                }
                resolve(player);
              },
              "onStateChange": (event) => {
                if (event.data === YT.PlayerState.PLAYING) {
                  this.setAttribute("playing", "");
                } else if (event.data === YT.PlayerState.ENDED || event.data === YT.PlayerState.PAUSED) {
                  this.removeAttribute("playing");
                }
              }
            }
          });
        }
        if (this.getAttribute("host") === "vimeo") {
          if (!window.Vimeo || !window.Vimeo.Player) {
            script.src = "https://player.vimeo.com/api/player.js";
            document.head.appendChild(script);
            await new Promise((resolve2) => {
              script.onload = resolve2;
            });
          }
          const player = new Vimeo.Player(this.querySelector("iframe"));
          if (muteVideo) {
            player.setMuted(true);
          }
          player.on("play", () => {
            this.setAttribute("playing", "");
          });
          player.on("pause", () => this.removeAttribute("playing"));
          player.on("ended", () => this.removeAttribute("playing"));
          resolve(player);
        }
      });
    } else {
      const videoElement = this.querySelector("video");
      this.setAttribute("loaded", "");
      videoElement.addEventListener("play", () => {
        this.setAttribute("playing", "");
        this.removeAttribute("suspended");
        if (this.#mustRemoveControlsAfterSuspend) {
          videoElement.controls = false;
        }
      });
      videoElement.addEventListener("pause", () => {
        if (!videoElement.seeking && videoElement.paused) {
          this.removeAttribute("playing");
        }
      });
      return videoElement;
    }
  }
  _playerHandler(target, prop) {
    if (this.getAttribute("host") === "youtube") {
      prop === "play" ? target.playVideo() : target.pauseVideo();
    } else {
      if (prop === "play" && !this.hasAttribute("host")) {
        target.play().catch((error) => {
          if (error.name === "NotAllowedError") {
            this.setAttribute("suspended", "");
            if (!this.hasAttribute("controls")) {
              this.#mustRemoveControlsAfterSuspend = true;
              target.controls = true;
            }
          }
        });
      } else {
        target[prop]();
      }
    }
  }
};
if (!window.customElements.get("video-media")) {
  window.customElements.define("video-media", VideoMedia);
}


// js/common/animation/marquee-text.js
var _currentAnimation, _MarqueeText_instances, direction_get, scroller_get, initialize_fn;
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);

var MarqueeText = class extends HTMLElement {
  constructor() {
    super();
    __privateAdd(this, _MarqueeText_instances);
    __privateAdd(this, _currentAnimation);
    inView(this, __privateMethod(this, _MarqueeText_instances, initialize_fn).bind(this), { margin: "400px" });
    if (this.hasAttribute("pause-on-hover")) {
      this.addEventListener("pointerenter", () => __privateGet(this, _currentAnimation)?.pause());
      this.addEventListener("pointerleave", () => __privateGet(this, _currentAnimation)?.play());
    }
  }
};
_currentAnimation = new WeakMap();
_MarqueeText_instances = new WeakSet();
direction_get = function() {
  return this.getAttribute("direction") === "right" ? 1 : -1;
};
scroller_get = function() {
  return this.shadowRoot.querySelector('[part="scroller"]');
};
initialize_fn = function() {
  this.attachShadow({ mode: "open" }).appendChild(document.createRange().createContextualFragment(`
      <slot part="scroller"></slot>
    `));
  const fragment = document.createDocumentFragment();
  for (let i = 1; i <= 5; ++i) {
    const node = this.firstElementChild.cloneNode(true);
    node.setAttribute("aria-hidden", "true");
    node.style.cssText = `position: absolute; inset-inline-start: ${100 * i * -__privateGet(this, _MarqueeText_instances, direction_get)}%;`;
    fragment.appendChild(node);
  }
  this.append(fragment);
  __privateSet(this, _currentAnimation, animate(__privateGet(this, _MarqueeText_instances, scroller_get), { transform: ["translateX(0)", `translateX(calc(var(--transform-logical-flip) * ${__privateGet(this, _MarqueeText_instances, direction_get) * 100}%))`] }, {
    duration: 1 / parseFloat(this.getAttribute("speed")) * (__privateGet(this, _MarqueeText_instances, scroller_get).clientWidth / 300),
    easing: "linear",
    repeat: Infinity
  }));
};
if (!window.customElements.get("marquee-text")) {
  window.customElements.define("marquee-text", MarqueeText);
}

function openTimeline(el) {
  const timeline_block = document.querySelectorAll('.product_timeline_block')
  timeline_block.forEach(block => {
    if (block == el)
      block.classList.add('is-active')
    else
      block.classList.remove('is-active')
  })
}

function containsHebrew(text) {
    const hebrewPattern = /[\u0590-\u05FF]/;
    return hebrewPattern.test(text);
}

function changeFontFamilyForHebrewElements(element, fontFamily) {
    const nodes = element.querySelectorAll('.grid-product__title');
    for (const node of nodes) {
        if (node.nodeType === Node.TEXT_NODE && containsHebrew(node.textContent)) {
            node.parentNode.style.setProperty('font-family', fontFamily, 'important');
        } else if (node.nodeType === Node.ELEMENT_NODE && containsHebrew(node.textContent)) {
            node.style.setProperty('font-family', fontFamily, 'important');
        }
    }
}

function toggleIngreModal() {
  $('.ingre-modal').toggleClass('open')
}

// Example usage
window.onload = () => {
    const targetElement = document.body;
    const newFontFamily = "pauza";  
    changeFontFamilyForHebrewElements(targetElement, newFontFamily);

  $('.faq-header').on('click', function() {
    $('.faq-header').removeClass('active')
    $(this).addClass('active')
  })

  $('.tab-header').on('click', function() {
    $('.tab-header').removeClass('active')
    $('.tab-header').attr('aria-selected', 'false')
    $(this).addClass('active')
    $(this).attr('aria-selected', 'true')
  })
}

document.addEventListener("DOMContentLoaded", function() {
    const blocks = document.querySelectorAll('.product_timeline_block');
    let currentIndex = 0; 

    const toggleActiveClass = () => {
      if(blocks.length > 0) {
        blocks.forEach(block => block.classList.remove('is-active'));
        blocks[currentIndex].classList.add('is-active');
        currentIndex = (currentIndex + 1) % blocks.length;
      }
    };

    toggleActiveClass();
    setInterval(toggleActiveClass, 3000);

  $('.filter-group-display__list-item input').on('change', function() {
    console.log('a')
    // Construct the new URL parameter
    var paramName = $(this).attr('name');
    var paramValue = $(this).is(':checked') ? $(this).val() : '';
  
    // Update the URL with the new parameter
    var url = new URL(window.location.href);
    if (paramValue) {
        url.searchParams.set(paramName, paramValue);
    } else {
        url.searchParams.delete(paramName);
    }
  
    // Perform AJAX call to reload page content (Example: fetch new content based on filter)
    $.ajax({
        url: url.href, // This uses the updated URL with the new parameters
        success: function(response) {
            // Assuming the response contains new HTML content to update part of your page
            $('#content').html(response); // Update part of your page with new content
        }
    });
  
    // Optionally, update the browser's URL in the address bar
    window.history.pushState({path:url.href}, '', url.href);
  })
});